/** **************************************************************************************
 * Copyright (c) 2023. Peter Lemke, SV-Studios                                          *
 * This File, its contents and by extension the corresponding project is property of    *
 * SV-Studios and may not be used without explicit permission to do so.                 *
 *                                                                                      *
 * management@sv-studios.net                                                            *
 *************************************************************************************** */

import React from "react";
import { DialogActions, DialogContent, DialogTitle } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import Switch from "@mui/material/Switch";
import MDTypography from "../MDTypography";
import MDBox from "../MDBox";
import MDButton from "../MDButton";
import { useDispatch, useSelector } from "react-redux";
import { flagsAction } from "../../store/flags/flags-slice";
import { toggleAndSaveFlag } from "../../store/flags/flags-actions";

const knownToggles = {
  "bot.frontend.experimentSwitch": "Aktivieren diesen Experimente-Dialog",
  "bot.frontend.newModuleOverview": "Neue Modulübersicht in Serverübersicht",
  "bot.frontend.customEmojiInTicketSystem": "Benutzerdefinierte Emojis im Ticketsystem",
  "bot.frontend.showModuleHelpMenu": "Modul-Hilfemenü anzeigen",
  "bot.frontend.stickyNavbarItems":
    "Bot und Guild bleiben beim Scrollen in der Navbar am oberen Bildschirmrand",
};

export default function FlagsDialog() {
  const {
    available: availableToggles,
    enabled: enabledToggles,
    showDialog,
  } = useSelector((state) => state.flags);
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(flagsAction.setShowDialog(false));
  };

  return (
    <>
      <Dialog
        open={showDialog}
        size="xl"
        className=" dark:bg-panel-800 dark:shadow-panel-900"
        handler={handleClose}
        dismiss={{
          ancestorScroll: false,
          outsidePointerDown: false,
          referencePointerDown: false,
          bubbles: false,
          escapeKey: false,
          enabled: false,
        }}
      >
        <DialogTitle className="dark:text-gray-200">Experimente</DialogTitle>
        <DialogContent divider className="grid grid-cols-3 dark:border-y-panel-500">
          <div className="col-span-2">
            <MDTypography
              className="font-normal dark:text-gray-400"
              variant="body2"
              horizontalAlign="justify"
              fontWeight="regular"
              gutterBottom
            >
              Hier kannst du auswählen welche Features du ausprobieren willst.
              <br />
              Einige Änderungen werden erst nach einem Neuladen der Seite wirksam.{" "}
            </MDTypography>
          </div>
          <div className="flex flex-col gap-1">
            {availableToggles.map((toggle) => (
              <MDBox display="flex" alignItems="center" key={toggle}>
                <Switch
                  defaultChecked={enabledToggles[toggle] || toggle === "bot.frontend.experimentSwitch"}
                  disabled={toggle === "bot.frontend.experimentSwitch"}
                  onChange={(e) => {
                    dispatch(toggleAndSaveFlag(toggle));
                  }}
                />
                <MDTypography className="dark:text-gray-200">{knownToggles[toggle] || toggle}</MDTypography>
              </MDBox>
            ))}
          </div>
        </DialogContent>
        <DialogActions className="grid grid-cols-1 gap-2 md:grid-cols-2 xl:grid-cols-3">
          <MDButton
            variant="gradient"
            color="secondary"
            id="allButton"
            onClick={handleClose}
            className="h-full w-full md:col-span-2 xl:col-span-1"
          >
            <span>Schließen</span>
          </MDButton>
        </DialogActions>
      </Dialog>
    </>
  );
}
